import { mapActions } from 'vuex';

import constants from '@/constants';

import ResponseUtil from '@/util/response-util';

import clockTimeEntry from '@/mixins/clocking/clockTimeEntry';

export default {
  mixins: [clockTimeEntry],

  methods: {
    ...mapActions(['saveSegmentTimeEntry']),

    postSegmentTimeEntry(
      unsavedTimeEntry,
      successCallBack,
      lastly,
      errorResetCallback,
    ) {
      this.saveSegmentTimeEntry(unsavedTimeEntry)
      .then((response) => successCallBack(response.data))
      .catch((error) => {
        this.showAppErrorDialog({
          message: ResponseUtil.getTimeRequestErrorMessage(
            error.response,
            { pairType: constants.TimePairType.SEGMENT },
          ),
        });
        errorResetCallback(error.response);
      })
      .finally(() => lastly());
    },
  },
};
